import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';

import { BillingService } from 'src/app/core/services/billing.service';
import { Invoice } from 'src/app/shared/models/invoice';
import { Subscription } from 'rxjs';
import { GooleAnalyticsEventsService } from 'src/app/core/services/goole-analytics-events.service';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/core/services/account.service';
import { DirectDebitComponent } from './invoice-details/direct-debit/direct-debit-dialog.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { StripeDialogComponent } from './invoice-details/stripe-dialog/stripe-dialog.component';
import { MatButton } from '@angular/material/button';
import { MatList, MatListItem } from '@angular/material/list';
import { MatCard } from '@angular/material/card';
import { AccountBalanceBillingCardComponent } from '../../../../shared/components/card/account-balance-billing-card/account-balance-billing-card.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { PageHeaderComponent } from '../../../../shared/components/layout/page-header/page-header.component';

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: true,
    imports: [PageHeaderComponent, MatProgressSpinner, AccountBalanceBillingCardComponent, MatIcon, MatCard, MatList, MatListItem, MatButton, RouterLink]
})
export class BillingComponent implements OnInit, OnDestroy {
  invoices: Invoice[];
  hasData = false;
  headerImage: string;
  invoiceState = '';
  private subscription: Subscription;

  loadingStripe: { [invoiceId: string]: boolean } = {};;
  directDebitEnabled: boolean;
  gocardlessUrl: string;
  customerId: string;
  directDebitLink = '';
  invoiceId: string;
  stripePublicKey = '';
  intentSecret: string;
  invoiceTotal = '';
  hideButton = false;
  invoicePaid = true;

  // tslint:disable-next-line: max-line-length
  constructor(private accountService: AccountService, private dialog: MatDialog, private router: Router, private billingService: BillingService, breakpointObserver: BreakpointObserver, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, private googleAnalyticsEvents: GooleAnalyticsEventsService, private title: Title) {
    this.matIconRegistry.addSvgIcon(
      'chevron_right',
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.base + 'assets/images/icons/chevron_right.svg')
    );

    breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.TabletPortrait
    ]).subscribe(result => {
      if (result.matches) {
        this.headerImage = './../../../../../assets/images/backgrounds/billing/billing_header_mobile.jpg';
      } else {
        this.headerImage = './../../../../../assets/images/backgrounds/billing/billing_header_desktop.jpg';
      }
    });
  }

  ngOnInit() {
    this.title.setTitle('Bruce\'s | Billing');
    this.fetchInvoices();
  }

  fetchInvoices() {
    this.subscription = this.billingService.getInvoices().subscribe(result => {
      const invoiceCount = result['size'];
      this.invoices = result['invoices'];
      if (invoiceCount !== 0) {
      } else {
        this.invoiceState = 'No invoices available';
      }
      this.hasData = true;
    }, err => {
      console.log('direct debit status fetch error: ', err);
    });
  }

  payInvoice(id, invoiceTotal) {
    this.invoiceId = id;
    this.invoiceTotal = invoiceTotal;
    this.loadingStripe[id] = true;
    this.loadStripe(id);
  }

  loadStripe(id) {
    this.billingService.createPaymentIntent(id).subscribe((result) => {
      this.intentSecret = result['intent_secret'];
      this.stripePublicKey = result['stripe_public_key'];

      this.fetchAccountInfo();

    }, err => {
      console.error('DID NOT FETCH PAYMENT INTENT ', err);
    });

  }

  fetchAccountInfo() {
    this.subscription = this.accountService.getDirectDebitStatus().subscribe(result => {
      const response = result['response'];
      this.directDebitEnabled = response['enabled'];
      this.gocardlessUrl = response['direct_debit_link'];
      this.customerId = response['customer_id'];
      this.directDebitLink = response['direct_debit_link'];
      this.hasData = true;

      if (this.directDebitEnabled) {
        this.proceedWithStripe();
      } else {
        const dialog = this.dialog.open(DirectDebitComponent, {
          data: {
            gocardlessUrl: this.gocardlessUrl,
            invoiceId: this.invoiceId
          }
        });

        dialog.afterClosed().subscribe(response => {
          if (response === 'no_thanks') {
            this.proceedWithStripe();
          } else if (response === 'setup_direct_debit') {
            window.open(this.gocardlessUrl, '_self');
            this
              .googleAnalyticsEvents
              .eventEmitter('setup', 'direct_debit', 'invoices', 10);
          }
          this.loadingStripe[this.invoiceId] = false;
        });
      };
    }, err => {
      console.error('GET DIRECT DEBIT STATUS ERROR! ', err);
    });
  }

  proceedWithStripe() {
    this.loadingStripe[this.invoiceId] = false;

    const dialog = this.dialog.open(StripeDialogComponent, {
      data: {
        intentSecret: this.intentSecret,
        stripePublicKey: this.stripePublicKey,
        invoiceTotal: this.invoiceTotal,
        invoiceId: this.invoiceId
      }
    });

     dialog.afterClosed().subscribe((stripeResponse) => {
      const response = stripeResponse || { event: "close" };
      if (response.event === "close") {
        this.hideButton = false;
      } else if (response.data !== "") {
        this.hideButton = true;
        this.invoicePaid = true;
      }
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  navigateTo(path: string, section: string, title: string) {
    this.googleEvent();
    if (path === 'settings') {
      this.router.navigate(['/settings']);
    }
  }

  googleEvent() {
    this
      .googleAnalyticsEvents
      .eventEmitter('invoices', 'invoice', 'billing', 10);
  }

}
